import React from 'react'
import EExamination from 'src/modules/EExamination'

const EExaminationPage = () => {
  return <EExamination />
}
export default EExaminationPage
